import { API, graphqlOperation } from "aws-amplify";

import { searchSkillsQuery } from "./graphql/queries";

const searchSkills = (term) =>
  API.graphql(graphqlOperation(searchSkillsQuery, { term }));

export default searchSkills;
